import "dayjs/locale/it"

import "./app.css"
import "./fonts.css"

import { ConfigProvider } from "antd"
import locale from "antd/lib/locale/it_IT"
import dayjs from "dayjs"
import it from "dayjs/locale/it"
import React from "react"
import { Route, BrowserRouter as Router } from "react-router-dom"
import styled, { ThemeProvider, createGlobalStyle } from "styled-components"

import RoutedApp from "./RoutedApp"
import ScrollToTop from "./_shared/components/ScrollToTop"
import { AppStateStore } from "./_shared/context/AppStateStore"

dayjs.locale(it)

// ----------------------------------------------------------------------------
//dayjs config

// ----------------------------------------------------------------------------

const App = (props) => {
    const initialState = {
        user: null,
        colors: "dark",
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case "SIGN_IN_FULFILLED": {
                return {
                    ...state,
                    token: action.payload.token,
                    user: action.payload.user,
                }
            }

            case "SIGN_OUT": {
                return {
                    ...state,
                    user: null,
                    token: null,
                }
            }

            default: {
                return {
                    ...state,
                }
            }
        }
    }

    const appTheme = {
        screenSizes: {
            mobile: 850,
        },

        shadows: {},
        colors: {
            textPrimary: "#000000",
            textSecondary: "#FFFFFF",
            textMuted: "#6B6B6B",
            buttonBackground: "#4791CC",
            buttonHover: "",
            shadowColor: "rgba(98, 98, 98, 0.15)",
            inputBorder: "#DBDBDB",
            backgroundPrimary: "rgb(1, 162,243)",
            white: "#FFFFFF",
            dividerColor: "rgba(0, 0, 0, 0.1)",
            success: "#67BD8F",

            // Admin
            primaryBackgroundColor: "#FFFFFF",
            sidebarColor:
                "linear-gradient(180deg,rgba(53, 49, 49, 1) 0%,rgba(0, 0, 0, 1) 100%)",
            secondaryColor: "#e4e6eb",
            errorColor: "rgb(255,59,48)",
            secondaryBackgroundColor: "#f0f5ff",
            dropzoneHover: "#dfe5f0",
            dropzoneTextColor: "#6e7a98",
        },
    }

    const GlobalStyle = createGlobalStyle`
        a {   
            color: ${(props) => props.theme.colors.primaryColor};
			border-color: ${(props) => props.theme.colors.primaryColor} ;

            :hover {
	            text-decoration: underline;
                color: ${(props) => props.theme.colors.primaryColor};
				border-color: ${(props) => props.theme.colors.primaryColor} ;
            }
        }   

		.ant-pagination-item{

			:hover{

				a{
					color: ${(props) => props.theme.colors.primaryColor};
				}
				
			}

		}

		.ant-pagination-item-active{
				border-color: ${(props) => props.theme.colors.primaryColor} ;	

				a {
					color: ${(props) => props.theme.colors.primaryColor};
				}
		}
    `

    return (
        <AppStateStore
            initialState={initialState}
            reducer={reducer}
            storeKey="welfarecare"
        >
            <ThemeProvider theme={appTheme}>
                <ConfigProvider locale={locale}>
                    <GlobalStyle />
                    <Router className={props.className}>
                        <ScrollToTop />
                        <Route path="/" component={RoutedApp} />
                    </Router>
                </ConfigProvider>
            </ThemeProvider>
        </AppStateStore>
    )
}

// ----------------------------------------------------------------------------
// Styled wrapper
// ----------------------------------------------------------------------------

const StyledApp = styled(App)`
    & {
        * {
            color: ${(props) => props?.theme?.colors?.textPrimary};
        }
    }
`

export default StyledApp
